import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_142: DocMigration = {
  maxSchemaVersion: "0.0.142",
  description: "Remove prewire field from electrical item catalog",
  apply(json: any) {
    for (const settingsId in json.settings) {
      const setting = json.settings[settingsId];

      if (setting.type === "ELECTRICAL_ITEM_CATALOG_SETTINGS") {
        const loadTypes = setting.loadTypes;
        for (const loadId in loadTypes) {
          const loadType = loadTypes[loadId];
          delete loadType.prewire;
        }
      }
    }
    return json;
  },
};

export default migration_0_0_142;
